import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";

export default function LoadingButton({ loading, children, ...props }) {
  return (
    <Button {...props} disabled={loading || props.disabled}>
      {loading ? (
        <>
          <Loader2 className="animate-spin mr-2" /> Carregando...
        </>
      ) : (
        children
      )}
    </Button>
  );
}
